import styled from 'styled-components';

import { device, hexToRGB } from '@/styles/helpers';

export const ScCards = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  margin-top: 8px;

  @media (${device.mobile}) {
    margin-top: 4px;
  }
`;

export const ScImageWrapper = styled.div<{ width: number }>`
  background: ${({ theme }) => hexToRGB(theme.blackColor, 0.5)};
  border-radius: 6px;
  width: ${({ width }) => width}px;

  & .cards-img {
    width: 100%;
    height: 40px;
    object-fit: contain;
  }

  @media (${device.mobile}) {
    & .cards-img {
      height: 35px;
      max-width: ${({ width }) => width}px;
    }
  }
`;
